import { createFeature, createReducer, on } from '@ngrx/store';

import * as actions from './maf-bundle.actions';
import { MafBundleQueryI } from 'src/app/api/maf-bundle/maf-bundle-query.int';
import { MafBundleResponseI } from 'src/app/api/maf-bundle/maf-bundle-result.int';

export interface State {
  data: MafBundleResponseI;
  errorMessage: string;
  loaded: boolean;
  loading: boolean;
  query: MafBundleQueryI;
}


export const initialState: State = {
  data: null,
  errorMessage: null,
  loaded: null,
  loading: null,
  query: null,
};

export default createFeature({
  name: 'mafBundle',
  reducer: createReducer(
  initialState,
  on(actions.error, (state: State, { messageText }): State => ({
    ...state,
    loading: true,
    loaded: false,
    errorMessage: messageText
  })),
  on(actions.load, (state: State, { query }): State => ({
    ...state,
    loading: true,
    query,
  })),
  on(actions.received, (state: State, { data }): State => ({
    ...state,
    loaded: true,
    loading: false,
    data,
  })),
  on(actions.reset, (_state: State, { }): State => ({
    ...initialState,
  })),
)}
);